export const handleOnClick = (onClick: () => void) => {
  if (onClick) {
    onClick();
  }
};

export default {
  handleOnClick
};
